class ComponentCollectionNav extends Theme.Component {
  connectedCallback() {
    super.connectedCallback();

    this.measure = this.measure.bind(this);

    this.addDirectEvent("resize", window, Theme.Helpers.debounce(this.measure, 150));

    this.measure();
  }

  measure() {
    const track = this.elements.track;

    if (!track) {
      return;
    }

    this.classList.remove("state--fits");

    const fits = track.scrollWidth <= track.clientWidth;

    this.classList.toggle("state--fits", fits);

    if (fits) {
      return;
    }

    const active = track.querySelector(".state--active");

    if (!active) {
      return;
    }

    track.scrollLeft = active.offsetLeft - (track.clientWidth - active.offsetWidth) / 2;
  }
}

customElements.define("component-collection-nav", ComponentCollectionNav);
